import React from "react";
import "./Executive.css";

import tliguiImg from "../images/permanent_com/tligi.webp";
import ghanemImg from "../images/permanent_com/ghanem.png";
import arounaImg from "../images/permanent_com/arouna.jpg";
import pyanaImg from "../images/scientific/pyana.jpg";
import johnimg from "../images/executive/john_mande.jpeg";
import yalaceimg from "../images/executive/yalace_kaboret.jpg";
import Thokoimg from "../images/executive/Thoko_Kapalamula.jpeg";
import Olefunkeimg from "../images/executive/Olefunke_Ola_Davies.jpeg";
import Abdelrahimimg from "../images/executive/Abdelrahim_Ali.jpg";
import Annaimg from "../images/executive/Anna_Marais.jpg";


const Executive = () => {
  const executiveMembers = [
    {
      name: "Dr. Noursaid Tligui",
      title: "President · IAV Hassan II, Rabat, Morocco",
      description: "President of the Executive Committee",
      image: tliguiImg,
    },
    {
      name: "Dr. John Demesei Mande",
      title: "1st Vice President · University of Nairobi, Kenya",
      description: "1st Vice President",
      image: johnimg,
    },
    {
      name: "Dr. Yalace Kaboret",
      title: "2nd Vice President · EISMV, Dakar, Senegal",
      description: "2nd Vice President",
      image: yalaceimg,
    },
    {
      name: "Dr. Thoko Kapalamula",
      title: "Secretary General · LUANAR, Malawi",
      description: "Secretary General",
      image: Thokoimg,
    },
    {
      name: "Dr. Patient Pyana Pati",
      title: "Treasurer · National Pedagogic University, DRC",
      description: "Treasurer",
      image: pyanaImg,
    },
    {
      name: "Dr. Arouna Njayou Ngapagna",
      title: "Member for Central Africa · Université des Montagnes, Cameroon",
      description: "Member for Central Africa",
      image: arounaImg,
    },
    {
      name: "Dr. Mohamed Ghanem",
      title: "Member for North Africa · Benha University, Egypt",
      description: "Member for North Africa",
      image: ghanemImg,
    },
    {
      name: "Dr. Olufunke Ola-Davies",
      title: "Member for West Africa · University of Ibadan, Nigeria",
      description: "Member for West Africa",
      image: Olefunkeimg,
    },
    {
      name: "Dr. Abdelrahim Ali",
      title: "Member for East Africa · University of West Kordofan, Sudan",
      description: "Member for East Africa",
      image: Abdelrahimimg,
    },
    {
      name: "Dr. Anna Marais",
      title: "Member for Southern Africa · University of Namibia",
      description: "Member for Southern Africa",
      image: Annaimg,
    },
  ];

  return (
    <div className="executive-section">
      <h1 className="executive-title">Executive Committee</h1>
      <div className="executive-container">
        {executiveMembers.map((member, index) => (
          <div key={index} className="executive-card">
            <div
              className="executive-image"
              style={{ backgroundImage: `url(${member.image})` }}
            >
              {member.description && (
                <div className="executive-hover">
                  <p>{member.description}</p>
                </div>
              )}
            </div>
            <h3 className="executive-name">{member.name}</h3>
            <p className="executive-title-small">{member.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Executive;
